/*
* 简历申请
 */
import React from 'react'
import {connect} from 'dva'
import {component_tool, framework_tool, utils_tool} from '@/tool';

let {WizContainer, WizReduxTemplate} = framework_tool;
import {WizTableForm} from '@/containers/common'
import {modelUtils} from '@/utils'

let {checkStrLength, Session} = utils_tool;
const {WizButton, WizSpin, WizRow, WizCol, WizForm, WizComponent, WizInput, WizModal, Wizmessage, WizCard, WizTabs} = component_tool


class ResumeApply extends WizContainer {
  componentName = 'ResumeApply'

  constructor(props) {
    super(props)
    this.state = {
      selectedRows: [],//选择的简历
      ids: [],
      data: undefined,
    }
  }

  _componentDidMount() {

  }

  propsAndStateOnChange = {
  resumeApplySave: this._resumeApplySaveOver.bind(this),
  };

  _resumeApplySaveOver(nextProps, nextState) {
    if (nextProps.resumeApplySave.code == 1) {
      wizNotice.success('简历申请成功');
      let {changeModal} = nextProps;
      changeModal && changeModal(false, true);
      return true;
    } else {
      let msg = nextProps.resumeApplySave.msg;
      wizNotice.error(msg);
      return false;
    }
  }


  setFileData(nextRows) {
    if (nextRows && nextRows instanceof Array) {
      let ids = []
      nextRows.forEach(item => {
        let {id} = item;
        ids.push(id);
      });
      this.setState({
        ids: ids,
        selectedRows: nextRows,
      })
    } else {
      this.setState({
        ids: [],
        selectedRows: [],
      })
    }
  }

  _resumeApplySave = e => {
    const {ids,selectedRows} = this.state;
    if (selectedRows  && selectedRows instanceof Array && selectedRows.length > 0 ) {
      let record = selectedRows[0];
      const {fullName,userName,orgName,positionName,applyTimesNextStr } = record;
      if (ids && ids instanceof Array && ids.length > 0) {
        WizModal.confirm({
          title: '信息确认',
          content:
            (<div>
              {'您即将为学员'}<font style={{ 'color': 'red' }}>{fullName}</font>
              {'（账号'}<font style={{ 'color': 'red' }}>{userName}</font>
              {'，岗位'}<font style={{ 'color': 'red' }}>{positionName}</font>
              {'，经销商'}<font style={{ 'color': 'red' }}>{orgName}</font>
              {'），创建一条面试数据，学员本次为'}<font style={{ 'color': 'red' }}>{applyTimesNextStr}</font>
              {'申请面试，是否确认？'}
          </div>),
          onOk: () => {
            this.doAction({
              path: "interviewResume/resumeApply",
              payload: {
                key: "interviewResume@resumeApplySaveKey",
                apiParams: {
                  id: ids[0],
                }
              }
            });
          },
          onCancel() { },
        });
      }else {
        wizNotice.warn('请选择需要申请的学员！');
      }
    }else {
      wizNotice.warn('请选择需要申请的学员！');
    }
  }

  render() {
    const {interviewResumeLoading} = this.props
    let resumeApplyConfig = WizTableForm.Config.resumeApply(this, {apiParams: {}});
    let tableFormProps = {
      title: '请选择需要进行面试的学员',
      showModal: false,
      visible: false,
      showSelectValue: true,
      showSelect: true,
      isScroll: false,
      tableSize: 'middle',
      selectType: 'radio',
      tableProps: {},
      initRows: [],
      value: [],
    };
    const footer = () => {
      return (
        <div className='form-btns' style={{textAlign: 'center'}}>
          <WizButton
            disabled={this.state.ids && this.state.ids instanceof Array && this.state.ids.length > 0 ? false : true}
            type='primary' htmlType='submit'>
            确认
          </WizButton>
        </div>
      )
    }

    let formProps = {
      ref: 'form',
      columns: [],
      onSubmit: this._resumeApplySave,
      record: null,
      preview: null,
      footer: footer(),
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 14}
      }
    }
    return <WizSpin tip={''} spinning={interviewResumeLoading}>
      <WizCard>
        <WizTableForm
          {...resumeApplyConfig} {...tableFormProps}
          onSelectedRows={this.setFileData.bind(this)}
        />
        <WizForm {...formProps}
                 ref={r => {
                   this.formData = r
                 }}
        />
      </WizCard>
    </WizSpin>
  }
}

const mapStateToProps = (state, ownProps) => {
  const {interviewResume} = state;
  const resumeApplySave = modelUtils.getModelEntity(interviewResume, 'interviewResume@resumeApplySaveKey');
  const load = modelUtils.getLoadingState(state, ['interviewResume']);
  return {
    resumeApplySave,
    ...load
  }
}
const options = {withRef: true}

export default connect(mapStateToProps, null, null, options)(ResumeApply)



